module.exports = __webpack_public_path__ + "img/infographic_terms_declining.cd42fa61.gif";